export const accountInfo = (state) => state.accountInfo;

export const supplierMenuList = (state) => state.supplierMenuList;

export const supplierInfo = (state) => state.supplierInfo;

export const merchantState = (state) => state.merchantState;

export const accountTypeByPath = (state) => state.accountTypeByPath;
